import React from "react";
import { SectionWrapper } from "../hoc";

const Feedbacks = () => {
	return <div>Feedbacks</div>;
};

export default SectionWrapper(Feedbacks, "need-one");
